module.exports = __webpack_public_path__ + "img/lineDark.7e4895ff.svg";